import styles from './HeroBanner.module.css';

export default function HeroBanner() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className={styles.heroContainer}>
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>Welcome to the Real Estate Revolution</h1>
        <p className={styles.heroSubtitle}>No Resumes. No Formalities. Just Real Talent. Real Challenges.</p>
        <div className={styles.ctaContainer}>
          <button 
            className={styles.primaryCta}
            onClick={() => scrollToSection('challenge')}
          >
            Pick a Challenge
          </button>
          <button 
            className={styles.secondaryCta}
            onClick={() => scrollToSection('opportunities')}
          >
            Current Opportunities
          </button>
        </div>
      </div>
      <div className={styles.heroImage}>
        <img
          src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80" 
          alt="Modern real estate"
        />
      </div>
    </div>
  );
}